export default __webpack_public_path__ + "static/media/icon-referral.88ff8227.svg";